var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPrintFill = function SvgPrintFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 21q-.824 0-1.412-.587A1.93 1.93 0 0 1 6 19v-2H4q-.824 0-1.412-.587A1.93 1.93 0 0 1 2 15v-4q0-1.275.875-2.137T5 8h14q1.276 0 2.137.863Q22 9.725 22 11v4q0 .824-.587 1.413A1.93 1.93 0 0 1 20 17h-2v2q0 .824-.587 1.413A1.93 1.93 0 0 1 16 21zM18 7H6V5q0-.824.588-1.412A1.93 1.93 0 0 1 8 3h8q.824 0 1.413.587Q18 4.176 18 5zm0 5.5q.424 0 .712-.287A.97.97 0 0 0 19 11.5a.97.97 0 0 0-.288-.713A.97.97 0 0 0 18 10.5a.97.97 0 0 0-.712.287.97.97 0 0 0-.288.713q0 .424.288.713.287.287.712.287M8 19h8v-4H8z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPrintFill);
export { ForwardRef as ReactComponent };